import React from 'react';
import {Box, Button, Card, CardContent, Grid, Stack, Typography} from "@mui/material";
import {CustomDatePicker} from "../../../../../components/datepicker";
import dayjs,{Dayjs} from 'dayjs';
import palette from "../../../../../theme/palette";



interface Props {
    handleNext:()=>void;
    handleBack:()=>void;
    setStartDate: (date: Dayjs | null) => void;
    setEndDate: (date: Dayjs | null) => void;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}


export const DateSelect: React.FC<Props> = ({setStartDate,setEndDate,startDate,endDate,handleNext,handleBack}) => {

    const handleCancel = () => {
        setStartDate(null);
        setEndDate(null);
    }

    const handleConfirm = () => {
        setStartDate(startDate);
        setEndDate(endDate);
        handleNext();
    }

    let disabled = !startDate || !endDate;
    return (
        <Stack margin={'auto'}>
            <Card>
                <CardContent sx={{padding:2}}>
                    <Stack>
                        <Typography fontWeight={500} fontSize={18} sx={{mb:2}}>
                            Select a Date Range for your Report
                        </Typography>
                        <Box sx={{mb:2}}>
                            <Typography fontWeight={400} fontSize={16} color={'text.secondary'}>
                                Select a Start and End Date
                            </Typography>
                        </Box>
                        <Grid
                            marginTop={20}
                            flexDirection={'row'}
                            container
                            justifyContent={'space-around'}
                            spacing={2}
                            mt={3}
                        >
                            <Grid item md={5}>
                                <CustomDatePicker date={startDate} setDate={setStartDate} label={'Start'}/>
                            </Grid>
                            <Grid item md={5}>
                                <CustomDatePicker date={endDate} setDate={setEndDate} label={'End'}/>
                            </Grid>
                        </Grid>
                        <Box sx={{}}>
                            <Grid
                                marginTop={20}
                                flexDirection={'row-reverse'}
                                container
                                spacing={3}
                                mt={3}
                            >
                                <Button disabled={disabled} sx={{color:palette.darkBlue}} onClick={handleConfirm}>
                                    Confirm
                                </Button>
                                <Button disabled={false} color="inherit" onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </Grid>
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    )
}